<template>
  <button
    v-on="listeners"
    v-bind="attrs"
    type="button"
    :class="[custom, sizeClasses, modeClasses, isLoading]"
    class="cbutton"
    :disabled="disabled"
    :aria-label="ariaLabel"
  >
    <span class="flex items-center">
      <base-icon
        class="hidden md:block mr-2"
        :name="icon"
        size="sm"
        v-if="forceIcon"
      />
      <base-icon
        class="block md:hidden"
        :name="icon"
      />
      <span class="hidden md:block">{{ text }}</span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'base-button-responsive',
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: 'button'
    },
    mode: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'md'
    },
    icon: {
      type: String,
      default: 'none'
    },
    forceIcon: {
      type: Boolean,
      default: false
    },
    custom: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: null,
    }
  },
  computed: {
    listeners: function () {
      return {
        ...this.$listeners
      }
    },
    attrs: function () {
      return {
        ...this.$attrs
      }
    },
    isLoading: function () {
      return { 'loader-in-element': this.loading }
    },
    sizeClasses: function () {
      return {
        'w-12 md:w-auto h-12 md:h-8 md:px-4': this.size === 'xs',
        'w-12 md:w-auto h-12 md:h-10 md:px-6': this.size === 'md'
      }
    },
    modeClasses: function () {
      return {
        'cbutton--primary': this.mode === 'primary',
        'cbutton--secondary text-white bg-secondary dark:bg-darkblue-600 hover:bg-secondary-800 dark:hover:bg-darkblue-500 active:bg-secondary-800 dark:active:bg-darkblue focus:bg-secondary-800': this.mode === 'secondary',
        'cbutton--prim-phantom bg-primary-50 dark:bg-darkblue text-primary-800 dark:text-primary-500 hover:text-primary-800 dark:hover:text-white hover:bg-primary-100 dark:hover:bg-primary focus:bg-primary-100 focus:text-primary-800': this.mode === 'primary-phantom',
        'cbutton--sec-phantom bg-secondary-50 dark:bg-darkblue-600 dark:hover:bg-darkblue-500 text-secondary dark:text-darkblue-300 hover:text-secondary-500 dark:hover:text-darkblue-200 focus:bg-secondary-100 focus:text-secondary': this.mode === 'secondary-phantom',
        'cbutton--prim-line bg-white dark:bg-darkblue text-primary hover:bg-primary-50 dark:hover:bg-darkblue-600 dark:hover:text-white border-primary active:bg-primary active:text-white dark:active:text-white focus:bg-primary-50 focus:text-primary': this.mode === 'primary-line',
        'cbutton--tools': this.mode === 'tools',
        'cbutton--core bg-white dark:bg-darkblue text-secondary dark:text-darkblue-200 hover:bg-primary-50 dark:hover:bg-darkblue-600 hover:text-primary-900 dark:hover:text-primary active:bg-primary-100 active:text-primary focus:bg-primary-100 focus:text-primary-900 hover:font-bold': this.mode === 'core',
        'cbutton--sec-phantom-blue bg-secondary-50 dark:bg-darkblue-600 text-secondary dark:text-darkblue-100 hover:bg-primary-800 hover:text-white dark:hover:bg-primary-600 dark:hover:text-white focus:text-white focus:bg-primary-800 dark:focus:bg-primary-600': this.mode === 'secondary-phantom-blue',
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.cbutton {
  @apply flex items-center justify-center space-x-1 text-sm font-semibold rounded-full md:rounded focus:outline-none transition-colors duration-300  focus:border-2 focus:border-black dark:focus:border-white;
  &.cbutton--primary {
    @apply text-white bg-primary-800 hover:bg-primary-900 active:bg-primary-900 focus:bg-primary-900;
  }
  &.cbutton--prim-line {
    @apply bg-white text-primary hover:bg-primary-50 border-2 border-solid border-primary active:bg-primary active:text-white focus:bg-primary-50 focus:text-primary focus:outline-none;
  }
  &.cbutton--tools {
    @apply text-white hover:bg-secondary-900 active:bg-secondary active:text-white focus:bg-secondary-900 focus:outline-none;
  }
  &.cbutton--core {
    @apply focus:outline-none;
  }
  &:active {
    transform: scale(0.96);
  }
  &:focus {
    outline: 2px solid black !important; 
    outline-offset: 2px !important;
  }
}
</style>
